// apps/landing-page/src/lib/extra-image-host.ts
// Validation of NEXT_PUBLIC_EXTRA_IMAGE_HOST, the one build-time extra host next.config.ts appends to
// images.remotePatterns (the demo media bucket). Next treats "*" and "**" in a remote-pattern hostname
// as wildcards, so an unvalidated value such as "**" would turn /_next/image into an open image proxy.
// Only a literal lowercase hostname is accepted; anything else fails the build.

export const EXTRA_IMAGE_HOST_VAR = 'NEXT_PUBLIC_EXTRA_IMAGE_HOST';
const MAX_HOSTNAME_LENGTH = 253;
// Dot-separated labels of a-z, 0-9 and "-" (not at either end of a label), with at least one dot.
// No wildcard, scheme, port, path, userinfo, whitespace or uppercase can match.
const LITERAL_HOSTNAME = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

export function isLiteralHostname(value: string): boolean {
  return value.length <= MAX_HOSTNAME_LENGTH && LITERAL_HOSTNAME.test(value);
}

/**
 * The validated extra image host, or null when the variable is unset or empty (an exact no-op).
 * Throws on any other value, which fails `next build`: a silently ignored typo would ship broken images.
 */
export function parseExtraImageHost(raw: string | undefined): string | null {
  if (raw === undefined || raw === '') return null;
  if (!isLiteralHostname(raw)) {
    throw new Error(
      `${EXTRA_IMAGE_HOST_VAR} must be a literal lowercase hostname such as "media.example.com" `
        + `(no wildcard, scheme, port or path); got ${JSON.stringify(raw)}`,
    );
  }
  return raw;
}
